import { createFileRoute } from '@tanstack/react-router'
import { SellerShow } from '@/features/sellers/pages/seller-show'

export const Route = createFileRoute('/_authenticated/sellers/$sellerId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { sellerId } = Route.useParams()
  return <SellerShow sellerId={sellerId} />
}
